module.exports = __webpack_public_path__ + "img/arrow_right.190bec00.svg";